import useScrollReveal from "./shared/useScrollReveal";

import icon1 from "../../Assets/levdc/fastcharging.webp";
import icon2 from "../../Assets/levdc/fleet.webp";
import icon3 from "../../Assets/levdc/Standard.webp";
import icon4 from "../../Assets/levdc/india.webp";

const REASONS = [
  {
    icon: icon1,
    title: "Faster Charging, Less Downtime",
    body: "DC charging delivers power directly to the vehicle battery, helping LEVs spend less time charging and more time on the road.",
  },
  {
    icon: icon2,
    title: "Built for High-Utilisation Fleets",
    body: "For delivery, passenger and cargo fleets, charging downtime directly affects operations. Faster charging can support quicker vehicle turnaround between trips or shifts.",
  },
  {
    icon: icon3,
    title: "One Standard, Wider Compatibility",
    body: "A common LEV DC charging standard can reduce fragmentation across compatible vehicles and make charging infrastructure more useful across multiple OEMs.",
  },
  {
    icon: icon4,
    title: "Designed for India’s LEV Ecosystem",
    body: "LEV DC is aligned with the needs of India’s rapidly growing electric 2W and 3W ecosystem rather than simply adapting infrastructure designed for larger EVs.",
  },
];

export default function WhyLevDc() {
  const ref = useScrollReveal();

  return (
    <section className="why2" id="why-levdc" ref={ref}>
      <div className="containers-min mx-auto px-4 py-12">
        <div className="why2-grid">
          <div className="why2-left">
            <p className="why2-eyebrow reveal">Why LEV DC Charger?</p>
            <h2 className="section-title reveal visible ">Built for the Way 2W &amp; 3W Fleets Charge</h2>
            <p className="why2-desc reveal pb-4">
             LEV DC is purpose-built for the charging needs of electric two-wheelers and three-wheelers. Its compact, deployment-friendly design makes DC charging practical across fleet depots, delivery hubs, public charging locations, and other space-conscious sites.
            </p>
            <p className="why2-desc reveal">
              From faster turnaround to efficient use of space, LEV DC is designed to keep light EVs moving and charging infrastructure ready for growing demand.
            </p>
          </div>

          <div className="why2-right">
            {REASONS.map((r) => (
              <div className="why2-item reveal" key={r.title}>
                <div className="why2-icon">
                  <img src={r.icon} alt={r.title} />
                </div>
                <div>
                  <h3>{r.title}</h3>
                  <p>{r.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}